
import { defineComponent } from 'vue'
import NursingTaskList from './NursingTaskList.vue'

export default defineComponent({
  name: 'NursingTasks',
  components : {
    NursingTaskList
  },
  data: () => ({
    panel: [],
    patients: [
        {
          "name": "Strawberry Shortcake Jamz",
          "gender": "Female",
          "age": "32",
          "problemSummary": "Hypertension, Diabetes, Asthma"
        },
        {
          "name": "Butter Cookie Jamz",
          "gender": "Male",
          "age": "35",
          "problemSummary": "Asthma, requires constant attention"
        },
        {
          "name": "Pleach Blush",
          "gender": "Male",
          "age": "34",
          "problemSummary": "Amnesia, Vital signs inconsistent"
        }
    ],
  }),

  methods: {
    all () {
        this.panel = ['foo', 'bar', 'baz']
    },
    none () {
      this.panel = []
    },
  }

})
